let useImageFileNameOnly = true;
let useInlineStyles = false;
let useSVGContent = false;
let selectionIconDataInfo: any = {};

let globalTextStyleSegments: Record<string, any[]> = {};
export class CoreEngineService {
  previousExecutionCache!: { style: string; text: string }[];
  selfClosingTags = ['img'];
  particulars: any = {
    styles: {},
    repeated: {},
  };
  styles: any[] = [];
  allNodeStrings: any = {};
  imagePathSVGMapping: any = {};
  fromFigmaImport: boolean = false;

  upDateStylesDetails(data: any, node: any) {
    if (data.style) {
      const style = {
        style: data.style,
        className: node['cssClassName'] || '.' + data.className,
      };
      if (!this.particulars.styles[this.className(node.name)]) {
        this.particulars.styles[this.className(node.name)] = [];
        this.particulars.styles[this.className(node.name)].push(style);
        this.styles.push(`${style.className} {${data.style}}`);
      } else {
        if (
          !this.particulars.styles[this.className(node.name)].find(
            (eachStyle: any) => eachStyle.style === style.style,
          )
        ) {
          this.particulars.styles[this.className(node.name)].push(style);
          this.styles.push(`${style.className} {${data.style}}`);
        } else {
          if (!this.particulars.repeated[this.className(node.name)]) {
            this.particulars.repeated[this.className(node.name)] = [];
          }
          this.particulars.repeated[this.className(node.name)].push(
            style.className,
          );
          let found: number = this.styles.findIndex(eachStyle =>
            eachStyle.includes(style.style),
          );
          if (found) {
            this.styles[found] = `${style.className}, ` + this.styles[found];
          }
        }
      }
    }
  }
  htmlMain(configDetails: any): any {
    selectionIconDataInfo = configDetails.selectionIconDataInfo;
    useSVGContent = configDetails.useSVGContent;
    useImageFileNameOnly = configDetails.useImageFileNameOnly;
    useInlineStyles = configDetails.useInlineStyles;
    globalTextStyleSegments = configDetails.globalTextStyleSegments;
    this.fromFigmaImport = configDetails.fromFigmaImport || false;
    this.styles = [];
    this.allNodeStrings = {};
    this.particulars = { styles: {}, repeated: {} };
    this.previousExecutionCache = [];
    this.imagePathSVGMapping = {};
    configDetails.sceneNode.forEach((node: any) => {
      this.updateParentNodeToEachChild(node, null);
    });
    let result = this.htmlWidgetGenerator(configDetails.sceneNode, true);

    // remove the initial \n that is made in Container.
    if (result.length > 0 && result.startsWith('\n')) {
      result = result.slice(1, result.length);
    }
    return {
      html: result,
      css: this.styles,
      imageAndSVGMapping: this.imagePathSVGMapping,
    };
  }

  updateParentNodeToEachChild(node: any, parentNode: any): void {
    node?.children?.forEach((child: any) => {
      child.parent = node;
      this.updateParentNodeToEachChild(child, node);
    });
    node.parent = parentNode;
  }

  retrieveTopFill(fills: any): any {
    if (
      fills &&
      typeof fills !== 'symbol' && // Symbol(figma.mixed)
      fills.length > 0
    ) {
      // on Figma, the top layer is always at the last position
      // reverse, then try to find the first layer that is visible, if any.
      return [...fills].reverse().find(d => d.visible !== false);
    }
  }

  indentString(str: string, indentLevel: number = 2): string {
    const regex = /^(?!\s*$)/gm;
    return str.replace(regex, ' '.repeat(indentLevel));
  }

  convertNodes(sceneNode: Array<any>): string {
    this.previousExecutionCache = [];

    let result = this.htmlWidgetGenerator(sceneNode);

    // remove the initial \n that is made in Container.
    if (result.length > 0 && result.startsWith('\n')) {
      result = result.slice(1, result.length);
    }

    return result;
  }

  htmlWidgetGenerator(
    sceneNode: ReadonlyArray<any>,
    root = false,
    level = 1,
  ): string {
    let comp = '';
    // filter non visible nodes. This is necessary at this step because conversion already happened.
    const visibleSceneNode = sceneNode.filter(
      d => d.visible || this.fromFigmaImport,
    );
    if (visibleSceneNode.length > 0 && visibleSceneNode[0].parent) {
      //identifying same name nodes
      const nodeNamesIndexes: any = {};
      visibleSceneNode.forEach((node, index) => {
        if (node.name in nodeNamesIndexes) {
          nodeNamesIndexes[node.name].push(index);
        } else {
          nodeNamesIndexes[node.name] = [index];
        }
      });
      let counter = 1;
      for (const nodeName in nodeNamesIndexes) {
        if (nodeNamesIndexes[nodeName].length === 1) {
          const nthChild = counter > 1 ? `:nth-child(${counter})` : '';
          const node = visibleSceneNode[nodeNamesIndexes[nodeName][0]];
          node['cssClassName'] = `${
            node.parent['cssClassName'] ||
            '.' + this.className(node.parent.name)
          } .${this.className(nodeName)}${nthChild}`;
          counter++;
        } else {
          for (const index of nodeNamesIndexes[nodeName]) {
            const nthChild = counter > 1 ? `:nth-child(${counter})` : '';
            const node = visibleSceneNode[index];
            node['cssClassName'] = `${
              node.parent['cssClassName'] ||
              '.' + this.className(node.parent.name)
            } .${this.className(nodeName)}${nthChild}`;
            counter++;
          }
        }
      }
    }
    visibleSceneNode.forEach(node => {
      switch (node.type) {
        case 'RECTANGLE':
        case 'ELLIPSE':
          const elipseContent = this.htmlContainer(node, '', []);
          comp += elipseContent;
          break;
        case 'GROUP':
          const groupContent = this.htmlGroup(node);
          comp += groupContent;
          break;
        case 'FRAME':
        case 'COMPONENT':
        case 'INSTANCE':
        case 'COMPONENT_SET':
          const frameContent = this.htmlFrame(node, level);
          comp += frameContent;
          break;
        case 'SECTION':
          const sectionContent = this.htmlSection(node);
          comp += sectionContent;
          break;
        case 'TEXT':
          const textContent = this.htmlText(node);
          comp += textContent;
          break;
        case 'LINE':
          const lineContent = this.htmlLine(node);
          comp += lineContent;
          break;
        case 'VECTOR':
          const vectorContent = this.htmlAsset(node);
          comp += vectorContent;
      }
    });

    return comp;
  }

  htmlContainer(
    node: any,
    children: string,
    additionalStyles: string[] = [],
  ): string {
    // ignore the view when size is zero or less
    // while technically it shouldn't get less than 0, due to rounding errors,
    // it can get to values like: -0.000004196293048153166
    if (node.width < 0 || node.height <= 0) {
      return children;
    }

    const builder = new HtmlDefaultBuilder(node)
      .commonPositionStyles(node)
      .commonShapeStyles(node);

    if (builder.styles || additionalStyles) {
      const props: any = {};
      let tag = 'div';
      let src = '';
      if (this.retrieveTopFill(node.fills)?.type === 'IMAGE') {
        if (!('children' in node) || !node?.children?.length) {
          tag = 'img';
          props['width'] = node.width.toFixed(0);
          props['height'] = node.height.toFixed(0);
          props['src'] =
            useImageFileNameOnly && !!node['fileName']
              ? './images/' + node['fileName']
              : node['svgPath'] || node.name;
          src = `src="${props['src']}" width="${props['width']}" height="${props['height']}"`;
        } else {
          builder.addStyles(
            builder.formatWithJSX('background-image', `url(${node.name})`),
          );
        }
      }

      const data: any = builder.buildWithSeperateCSS(additionalStyles);
      props['class'] = data.className || '';
      src += props['class'] ? ` class="${props['class']}"` : '';
      if ((data.style && node['cssClassName']) || props['class']) {
        if (useInlineStyles) {
          src += ` style="${data.style}"`;
        }
      }
      this.upDateStylesDetails(data, node);
      const fileName = !!node['fileName']
        ? node['fileName'].split('.svg')[0]
        : '';
      let assetTag = `\n<${tag} ${src}></${tag}>`;
      if (children) {
        const childContent = this.indentString(children);
        assetTag = `\n<${tag} ${src}>${childContent}\n</${tag}>`;
      } else if (this.selfClosingTags.indexOf(tag) !== -1) {
        assetTag = `\n<${tag} ${src} />`;
      }

      if (
        !!fileName &&
        useSVGContent &&
        selectionIconDataInfo?.imagesPath?.[fileName]
      ) {
        const classes = props['class'] ? ` class="${props['class']}"` : '';
        const svgTag = `\n<div ${classes}>${
          selectionIconDataInfo?.imagesPath?.[fileName].data
        }
        ${children ? this.indentString(children) : ''}</div>`;
        this.imagePathSVGMapping[node['fileName']] =
          selectionIconDataInfo?.imagesPath?.[fileName].data;
        return svgTag;
      }

      return assetTag;
    }

    return children;
  }

  htmlGroup(node: any): string {
    if (node.width < 0 || node.height <= 0 || !node?.children?.length) {
      return '';
    }

    const builder = new HtmlDefaultBuilder(node).commonPositionStyles(node);

    if (builder.styles) {
      //const attr = builder.build();
      const data: any = builder.buildWithSeperateCSS();
      //console.log('htmlGroup: ', data, builder, node);
      this.upDateStylesDetails(data, node);

      const generator = this.htmlWidgetGenerator(node?.children || []);
      const childContent = this.indentString(generator);

      return `\n<div class="${data.className}" ${
        useInlineStyles ? `style="${data.style}"` : ''
      }>${childContent}\n</div>`;
    }

    return this.htmlWidgetGenerator(node?.children || []);
  }

  htmlFrame(node: any, level: number): string {
    const childrenStr = this.htmlWidgetGenerator(
      this.commonSortChildrenWhenInferredAutoLayout(node),
      false,
      level + 1,
    );

    const rowColumn = this.htmlAutoLayoutProps(
      node,
      node.layoutMode !== 'NONE' ? node : node.inferredAutoLayout || [],
    );
    const containerContent = this.htmlContainer(node, childrenStr, rowColumn);
    return containerContent;
  }

  commonSortChildrenWhenInferredAutoLayout(node: any) {
    if (!node?.children || node?.children?.length <= 1) {
      return node?.children || [];
    }

    if (
      !!node?.children?.length &&
      'inferredAutoLayout' in node &&
      node.inferredAutoLayout !== null
    ) {
      const children = [...node.children];
      switch (node.inferredAutoLayout.layoutMode) {
        case 'HORIZONTAL':
          return children.sort((a, b) => a.x - b.x);
        // NONE is a bug from Figma.
        case 'NONE':
        case 'VERTICAL':
          return children.sort((a, b) => a.y - b.y);
      }
    }
    return node?.children || [];
  }

  htmlAutoLayoutProps(node: any, autoLayout: any): string[] {
    return this.formatMultipleJSXArray({
      'flex-direction': autoLayout?.layoutMode === 'HORIZONTAL' ? '' : 'column',
      'justify-content': this.getJustifyContent(autoLayout),
      'align-items': this.getAlignItems(autoLayout),
      gap:
        autoLayout?.itemSpacing > 0 &&
        autoLayout?.primaryAxisAlignItems !== 'SPACE_BETWEEN'
          ? autoLayout.itemSpacing
          : '',
      display:
        node.parent &&
        'layoutMode' in node.parent &&
        node.parent.layoutMode === autoLayout?.layoutMode
          ? 'flex'
          : 'inline-flex',
    });
  }

  getJustifyContent(node: any): string {
    switch (node?.primaryAxisAlignItems) {
      case 'MIN':
        return 'flex-start';
      case 'CENTER':
        return 'center';
      case 'MAX':
        return 'flex-end';
      case 'SPACE_BETWEEN':
        return 'space-between';
    }
    return '';
  }

  getAlignItems(node: any): string {
    switch (node?.counterAxisAlignItems) {
      case 'MIN':
        return 'flex-start';
      case 'CENTER':
        return 'center';
      case 'MAX':
        return 'flex-end';
      case 'BASELINE':
        return 'baseline';
    }
    return '';
  }

  formatMultipleJSXArray(styles: Record<string, string | number>): string[] {
    const dummyHTMLBuilder = new HtmlDefaultBuilder();
    return (
      dummyHTMLBuilder
        .getEntries(styles)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([key, value]) => value !== '')
        .map(([key, value]) => dummyHTMLBuilder.formatWithJSX(key, value))
    );
  }

  htmlSection(node: any): string {
    const childrenStr = this.htmlWidgetGenerator(node?.children || []);
    const builder = new HtmlDefaultBuilder(node)
      .size(node)
      .position(node)
      .applyFillsToStyle(node.fills, 'background');

    const data: any = builder.buildWithSeperateCSS();
    //console.log('htmlSection: ', data, builder, node);
    const childrenData = childrenStr ? this.indentString(childrenStr) : '';

    this.upDateStylesDetails(data, node);
    return `\n<div class="${data.className}" ${
      useInlineStyles ? `style="${data.style}"` : ''
    }>${childrenData}\n</div>`;
  }

  htmlText(node: any): string {
    const layoutBuilder = new HtmlDefaultBuilder(node)
      .commonPositionStyles(node)
      .textAlign(node);

    const styledHtml = layoutBuilder.getTextSegments(node.id);
    this.previousExecutionCache.push(...styledHtml);

    let content = '';
    if (styledHtml.length === 1) {
      layoutBuilder.addStyles(styledHtml[0].style);
      content = styledHtml[0].text;
    } else {
      content = styledHtml
        .map(style => {
          const className =
            'dynamic_span_class-' + Math.random().toString(36).substring(7);
          this.styles.push(`\n.${className} {${style.style}}`);
          if (!this.particulars[className]) this.particulars[className] = [];
          this.particulars[className].push({
            style: style.style,
          });
          return `<span class="${className}" ${
            useInlineStyles ? `style="${data.style}"` : ''
          } >${style.text}</span>`;
          //return `<span style="${style.style}">${style.text}</span>`;
        })
        .join('');
    }

    const data: any = layoutBuilder.buildWithSeperateCSS();
    if (node?.parent && !data.style.includes('z-index:')) {
      const index = node.parent.children?.indexOf(node);
      if (index !== undefined && index !== -1) {
        data.style += `z-index: ${index + 1};`;
      }
    }
    //console.log('htmlText: ', data, layoutBuilder, node);
    this.upDateStylesDetails(data, node);

    const tag = data?.className?.toLowerCase().includes('label')
      ? 'label'
      : 'span';
    return `\n<${tag} class="${data.className}" ${
      useInlineStyles ? `style="${data.style}"` : ''
    }>${content}</${tag}>`;
  }

  htmlLine(node: any): string {
    const builder = new HtmlDefaultBuilder(node)
      .commonPositionStyles(node)
      .commonShapeStyles(node);

    const data: any = builder.buildWithSeperateCSS();
    this.upDateStylesDetails(data, node);

    //console.log('htmlLine: ', data, builder, node);
    return `\n<div class="${data.className}" ${
      useInlineStyles ? `style="${data.style}"` : ''
    }></div>`;
  }

  htmlAsset(node: any): string {
    if (
      !('opacity' in node) ||
      !('layoutAlign' in node) ||
      !('fills' in node)
    ) {
      return '';
    }

    const builder = new HtmlDefaultBuilder(node)
      .commonPositionStyles(node)
      .commonShapeStyles(node);

    let tag = 'div';
    let src = '';
    const props: any = {};
    if (this.retrieveTopFill(node.fills)?.type === 'IMAGE') {
      tag = 'img';
      props['width'] = node.width.toFixed(0);
      props['height'] = node.height.toFixed(0);
      props['src'] =
        useImageFileNameOnly && !!node['fileName']
          ? './images/' + node['fileName']
          : node['svgPath'] || node.name;
      src = `src="${props['src']}" width="${props['width']}" height="${props['height']}"`;
    } else if (node['svgPath'] || node['fileName']) {
      tag = 'img';
      props['src'] =
        useImageFileNameOnly && !!node['fileName']
          ? './images/' + node['fileName']
          : node['svgPath'] || node.name;
      src = `src="${props['src']}"`;
    }

    const data: any = node['svgPath'] ? {} : builder.buildWithSeperateCSS();
    props['class'] = data.className || '';
    src += props['class'] ? ` class="${props['class']}"` : '';
    this.upDateStylesDetails(data, node);
    const fileName = !!node['fileName']
      ? node['fileName'].split('.svg')[0]
      : '';
    const assetTag =
      this.selfClosingTags.indexOf(tag) !== -1
        ? `\n<${tag} ${src} ${useInlineStyles ? `style="${data.style}"` : ''}/>`
        : `\n<${tag} ${src} ${
            useInlineStyles ? `style="${data.style}"` : ''
          }></${tag}>`;

    if (
      !!fileName &&
      useSVGContent &&
      selectionIconDataInfo?.imagesPath?.[fileName]
    ) {
      const classes = props['class'] ? ` class="${props['class']}"` : '';
      const svgTag = `\n<div ${classes}>${selectionIconDataInfo?.imagesPath?.[fileName].data}</div>`;
      this.imagePathSVGMapping[node['fileName']] =
        selectionIconDataInfo?.imagesPath?.[fileName].data;
      return svgTag;
    }

    return assetTag;
  }

  className(name: string): string {
    const words = name.split(/[^a-zA-Z0-9]+/);
    const camelCaseWords = words.map((word, index) => {
      if (index === 0) {
        const cleanedWord = word.replace(/^[^a-zA-Z]+/g, '');
        return (
          cleanedWord.charAt(0).toUpperCase() +
          cleanedWord.slice(1).toLowerCase()
        );
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return camelCaseWords.join('');
  }
}

export class HtmlDefaultBuilder {
  styles: Array<string>;
  //isJSX: boolean;
  visible: boolean;
  name: string = '';

  constructor(node?: any) {
    //this.isJSX = optIsJSX;
    this.styles = [];
    this.visible = node?.visible;
    this.name = node?.name ? this.className(node.name) : '';
  }

  formatWithJSX(property: string, value: number | string): string {
    return typeof value === 'number'
      ? `${property}: ${this.sliceNum(value)}px`
      : `${property}: ${value}`;
  }

  sliceNum(num: number): string {
    return num.toFixed(2).replace(/\.00$/, '');
  }

  className(name: string): string {
    const words = name.split(/[^a-zA-Z0-9]+/);
    const camelCaseWords = words.map((word, index) => {
      if (index === 0) {
        const cleanedWord = word.replace(/^[^a-zA-Z]+/g, '');
        return (
          cleanedWord.charAt(0).toUpperCase() +
          cleanedWord.slice(1).toLowerCase()
        );
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return camelCaseWords.join('');
  }

  commonPositionStyles(node: any): this {
    this.size(node);
    this.autoLayoutPadding(node);
    this.position(node);
    this.blend(node);
    return this;
  }

  commonShapeStyles(node: any): this {
    this.applyFillsToStyle(
      node.fills,
      node.type === 'TEXT'
        ? 'text'
        : node.type === 'VECTOR'
        ? 'color'
        : 'background',
    );
    this.shadow(node);
    this.border(node);
    this.blur(node);
    return this;
  }

  addStyles(...newStyles: string[]) {
    this.styles.push(...newStyles.filter(style => style));
  }

  blend(node: any): this {
    this.addStyles(
      this.htmlVisibility(node),
      ...this.htmlRotation(node),
      this.htmlOpacity(node),
      this.htmlBlendMode(node),
    );
    return this;
  }

  htmlBlendMode(node: any): string {
    if (node.blendMode !== 'NORMAL' && node.blendMode !== 'PASS_THROUGH') {
      let blendMode = '';
      switch (node.blendMode) {
        case 'MULTIPLY':
          blendMode = 'multiply';
          break;
        case 'SCREEN':
          blendMode = 'screen';
          break;
        case 'OVERLAY':
          blendMode = 'overlay';
          break;
        case 'DARKEN':
          blendMode = 'darken';
          break;
        case 'LIGHTEN':
          blendMode = 'lighten';
          break;
        case 'COLOR_DODGE':
          blendMode = 'color-dodge';
          break;
        case 'COLOR_BURN':
          blendMode = 'color-burn';
          break;
        case 'HARD_LIGHT':
          blendMode = 'hard-light';
          break;
        case 'SOFT_LIGHT':
          blendMode = 'soft-light';
          break;
        case 'DIFFERENCE':
          blendMode = 'difference';
          break;
        case 'EXCLUSION':
          blendMode = 'exclusion';
          break;
        case 'HUE':
          blendMode = 'hue';
          break;
        case 'SATURATION':
          blendMode = 'saturation';
          break;
        case 'COLOR':
          blendMode = 'color';
          break;
        case 'LUMINOSITY':
          blendMode = 'luminosity';
          break;
      }

      if (blendMode) {
        return this.formatWithJSX('mix-blend-mode', blendMode);
      }
    }
    return '';
  }

  htmlOpacity(node: any): string {
    return node.opacity !== undefined && node.opacity !== 1
      ? `opacity: ${this.sliceNum(node.opacity)}`
      : '';
  }

  htmlVisibility(node: any): string {
    // [when testing] node.visible can be undefined

    // When something is invisible in Figma, it isn't gone. Groups can make use of it.
    // Therefore, instead of changing the visibility (which causes bugs in nested divs),
    // this plugin is going to ignore color and stroke
    return node.visible !== undefined && !node.visible
      ? this.formatWithJSX('visibility', 'hidden')
      : '';
  }

  htmlRotation(node: any): string[] {
    // that's how you convert angles to clockwise radians: angle * -pi/180
    // using 3.14159 as Pi for enough precision and to avoid importing math lib.
    return node.rotation !== undefined && Math.round(node.rotation) !== 0
      ? [
          this.formatWithJSX(
            'transform',
            `rotate(${this.sliceNum(-node.rotation)}deg)`,
          ),
          this.formatWithJSX('transform-origin', '0 0'),
        ]
      : [];
  }

  getCommonRadius(node: any): any {
    if (
      'cornerRadius' in node &&
      typeof node.cornerRadius !== 'symbol' &&
      node.cornerRadius
    ) {
      return { all: node.cornerRadius };
    }

    if ('topLeftRadius' in node) {
      if (
        node.topLeftRadius === node.topRightRadius &&
        node.topLeftRadius === node.bottomRightRadius &&
        node.topLeftRadius === node.bottomLeftRadius
      ) {
        return { all: node.topLeftRadius };
      }

      return {
        topLeft: node.topLeftRadius,
        topRight: node.topRightRadius,
        bottomRight: node.bottomRightRadius,
        bottomLeft: node.bottomLeftRadius,
      };
    }

    return { all: 0 };
  }

  handleIndividualRadius(node: any): number[] {
    const cornerValues = [
      node.topLeftRadius,
      node.topRightRadius,
      node.bottomRightRadius,
      node.bottomLeftRadius,
    ];
    return cornerValues;
  }

  htmlBorderRadius(node: any): string[] {
    const radius = this.getCommonRadius(node);
    if (node.type === 'ELLIPSE') {
      return [this.formatWithJSX('border-radius', 9999)];
    }

    const comp: string[] = [];
    let cornerValues: number[] = [0, 0, 0, 0];

    if ('all' in radius) {
      if (radius.all === 0) {
        return [];
      }

      comp.push(this.formatWithJSX('border-radius', radius.all));
    } else if ('topLeftRadius' in node) {
      cornerValues = this.handleIndividualRadius(node);
      comp.push(
        ...cornerValues
          .filter(d => d > 0)
          .map((value, index) => {
            const property = [
              'border-top-left-radius',
              'border-top-right-radius',
              'border-bottom-right-radius',
              'border-bottom-left-radius',
            ][index];
            return this.formatWithJSX(property, value);
          }),
      );
    }

    if (
      'children' in node &&
      'clipsContent' in node &&
      !!node?.children?.length &&
      node.clipsContent === true
    ) {
      comp.push(this.formatWithJSX('overflow', 'hidden'));
    }
    return comp;
  }

  commonStroke(node: any, divideBy: number = 1): any {
    if (!('strokes' in node) || !node.strokes || node.strokes.length === 0) {
      return null;
    }

    if ('strokeTopWeight' in node) {
      return node.strokeTopWeight === node.strokeBottomWeight &&
        node.strokeTopWeight === node.strokeLeftWeight &&
        node.strokeTopWeight === node.strokeRightWeight
        ? { all: node.strokeTopWeight / divideBy }
        : {
            left: node.strokeLeftWeight / divideBy,
            top: node.strokeTopWeight / divideBy,
            right: node.strokeRightWeight / divideBy,
            bottom: node.strokeBottomWeight / divideBy,
          };
    }
    return typeof node.strokeWeight !== 'symbol' && node.strokeWeight !== 0
      ? { all: node.strokeWeight / divideBy }
      : null;
  }

  retrieveTopFill(fills: any): any {
    if (fills && typeof fills !== 'symbol' && fills.length > 0) {
      // on Figma, the top layer is always at the last position
      // reverse, then try to find the first layer that is visible, if any.
      return [...fills].reverse().find(d => d.visible !== false);
    }
  }

  htmlColor(
    color: { r: number; g: number; b: number },
    alpha: number = 1,
  ): string {
    if (color.r === 1 && color.g === 1 && color.b === 1 && alpha === 1) {
      return 'white';
    }

    if (color.r === 0 && color.g === 0 && color.b === 0 && alpha === 1) {
      return 'black';
    }

    // Return # when possible.
    if (alpha === 1) {
      const r = Math.round(color.r * 255);
      const g = Math.round(color.g * 255);
      const b = Math.round(color.b * 255);

      const toHex = (num: number): string => num.toString(16).padStart(2, '0');
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
    }

    const r = this.sliceNum(color.r * 255);
    const g = this.sliceNum(color.g * 255);
    const b = this.sliceNum(color.b * 255);
    const a = this.sliceNum(alpha);

    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  htmlColorFromFills(fills: any): string {
    const fill = this.retrieveTopFill(fills);
    if (fill && fill.type === 'SOLID') {
      return this.htmlColor(fill.color, fill.opacity);
    }
    return fill &&
      (fill.type === 'GRADIENT_LINEAR' ||
        fill.type === 'GRADIENT_ANGULAR' ||
        fill.type === 'GRADIENT_RADIAL' ||
        fill.type === 'GRADIENT_DIAMOND') &&
      fill.gradientStops.length
      ? this.htmlColor(fill.gradientStops[0].color, fill.opacity)
      : '';
  }

  border(node: any): this {
    this.addStyles(...this.htmlBorderRadius(node));

    const commonBorder = this.commonStroke(node);
    if (!commonBorder) {
      return this;
    }

    const color = this.htmlColorFromFills(node.strokes);
    const borderStyle = node.dashPattern.length > 0 ? 'dotted' : 'solid';

    const consolidateBorders = (border: number): string =>
      [`${this.sliceNum(border)}px`, color, borderStyle]
        .filter(d => d)
        .join(' ');

    if ('all' in commonBorder) {
      if (commonBorder.all === 0) {
        return this;
      }
      const weight = commonBorder.all;
      if (!!color)
        this.addStyles(
          this.formatWithJSX('border', consolidateBorders(weight)),
        );
    } else {
      if (commonBorder.left !== 0) {
        this.addStyles(
          this.formatWithJSX(
            'border-left',
            consolidateBorders(commonBorder.left),
          ),
        );
      }
      if (commonBorder.top !== 0) {
        this.addStyles(
          this.formatWithJSX(
            'border-top',
            consolidateBorders(commonBorder.top),
          ),
        );
      }
      if (commonBorder.right !== 0) {
        this.addStyles(
          this.formatWithJSX(
            'border-right',
            consolidateBorders(commonBorder.right),
          ),
        );
      }
      if (commonBorder.bottom !== 0) {
        this.addStyles(
          this.formatWithJSX(
            'border-bottom',
            consolidateBorders(commonBorder.bottom),
          ),
        );
      }
    }
    return this;
  }

  commonIsAbsolutePosition(node: any) {
    if ('layoutAlign' in node) {
      if (!node.parent || node.parent === undefined) {
        return false;
      }

      const parentLayoutIsNone =
        'layoutMode' in node.parent && node.parent.layoutMode === 'NONE';
      const hasNoLayoutMode = !('layoutMode' in node.parent);

      if (
        node.layoutPositioning === 'ABSOLUTE' ||
        parentLayoutIsNone ||
        hasNoLayoutMode
      ) {
        return true;
      }
    }
    // No position when parent is inferred auto layout.
    if (
      node.parent &&
      'layoutMode' in node.parent &&
      node.parent.inferredAutoLayout !== null
    ) {
      return false;
    }

    return false;
  }

  getCommonPositionValue(node: any): { x: number; y: number } {
    return node.parent && node.parent.type === 'GROUP'
      ? { x: node.x - node.parent.x, y: node.y - node.parent.y }
      : { x: node.x, y: node.y };
  }

  position(node: any): this {
    if (this.commonIsAbsolutePosition(node)) {
      const { x, y } = this.getCommonPositionValue(node);

      this.addStyles(
        this.formatWithJSX('left', x),
        this.formatWithJSX('top', y),
        this.formatWithJSX('position', 'absolute'),
      );
    } else {
      const _node = node['inferredAutoLayout'] || node;
      if (
        node.type === 'GROUP' ||
        ('layoutMode' in node &&
          (_node?.layoutMode === 'NONE' ||
            _node?.layoutMode === 'HORIZONTAL' ||
            _node?.layoutMode === 'VERTICAL'))
      ) {
        this.addStyles(this.formatWithJSX('position', 'relative'));
      }
    }

    return this;
  }

  applyFillsToStyle(
    paintArray: any,
    property: 'text' | 'background' | 'color',
  ): this {
    if (property === 'text') {
      this.addStyles(
        this.formatWithJSX('text', this.htmlColorFromFills(paintArray)),
      );
      return this;
    }

    const backgroundValues = this.buildBackgroundValues(paintArray);
    if (backgroundValues) {
      this.addStyles(this.formatWithJSX(property, backgroundValues));
    }

    return this;
  }

  htmlGradientFromFills(fills: any): string {
    const fill = this.retrieveTopFill(fills);
    if (fill?.type === 'GRADIENT_LINEAR') {
      return this.htmlLinearGradient(fill);
    } else if (fill?.type === 'GRADIENT_ANGULAR') {
      return this.htmlAngularGradient(fill);
    } else if (fill?.type === 'GRADIENT_RADIAL') {
      return this.htmlRadialGradient(fill);
    }
    return '';
  }

  gradientAngle2(fill: any): number {
    const x1 = fill.gradientTransform[0][2];
    const y1 = fill.gradientTransform[1][2];
    const x2 = fill.gradientTransform[0][0] + x1;
    const y2 = fill.gradientTransform[1][0] + y1;
    const dx = x2 - x1;
    const dy = y1 - y2;
    const radians = Math.atan2(dy, dx);
    const unadjustedAngle = (radians * 180) / Math.PI;
    const adjustedAngle = unadjustedAngle + 90;
    return adjustedAngle;
  }

  cssGradientAngle(angle: number): number {
    // Convert Figma angle to CSS angle.
    const cssAngle = angle; // Subtract 235 to make it start from the correct angle.
    // Normalize angle: if negative, add 360 to make it positive.
    return cssAngle < 0 ? cssAngle + 360 : cssAngle;
  }

  htmlLinearGradient(fill: any): string {
    // Adjust angle for CSS.
    const figmaAngle = this.gradientAngle2(fill);
    const angle = this.cssGradientAngle(figmaAngle).toFixed(0);

    const mappedFill = fill.gradientStops
      .map((stop: any) => {
        const color = this.htmlColor(
          stop.color,
          stop.color.a * (fill.opacity ?? 1),
        );
        const position = `${(stop.position * 100).toFixed(0)}%`;
        return `${color} ${position}`;
      })
      .join(', ');

    return `linear-gradient(${angle}deg, ${mappedFill})`;
  }

  htmlAngularGradient(fill: any): string {
    const angle = this.gradientAngle2(fill).toFixed(0);
    const centerX = (fill.gradientTransform[0][2] * 100).toFixed(2);
    const centerY = (fill.gradientTransform[1][2] * 100).toFixed(2);

    const mappedFill = fill.gradientStops
      .map((stop: any) => {
        const color = this.htmlColor(
          stop.color,
          stop.color.a * (fill.opacity ?? 1),
        );
        const position = `${(stop.position * 360).toFixed(0)}deg`;
        return `${color} ${position}`;
      })
      .join(', ');

    return `conic-gradient(from ${angle}deg at ${centerX}% ${centerY}%, ${mappedFill})`;
  }

  getGradientTransformCoordinates(gradientTransform: number[][]): {
    centerX: string;
    centerY: string;
    radiusX: string;
    radiusY: string;
  } {
    const a = gradientTransform[0][0];
    const b = gradientTransform[0][1];
    const c = gradientTransform[1][0];
    const d = gradientTransform[1][1];
    const e = gradientTransform[0][2];
    const f = gradientTransform[1][2];

    const scaleX = Math.sqrt(a ** 2 + b ** 2);
    const scaleY = Math.sqrt(c ** 2 + d ** 2);

    const centerX = ((e * scaleX * 100) / (1 - scaleX)).toFixed(2);
    const centerY = (((1 - f) * scaleY * 100) / (1 - scaleY)).toFixed(2);

    const radiusX = (scaleX * 100).toFixed(2);
    const radiusY = (scaleY * 100).toFixed(2);

    return { centerX, centerY, radiusX, radiusY };
  }

  htmlRadialGradient(fill: any): string {
    const mappedFill = fill.gradientStops
      .map((stop: any) => {
        const color = this.htmlColor(
          stop.color,
          stop.color.a * (fill.opacity ?? 1),
        );
        const position = `${(stop.position * 100).toFixed(0)}%`;
        return `${color} ${position}`;
      })
      .join(', ');

    const { centerX, centerY, radiusX, radiusY } =
      this.getGradientTransformCoordinates(fill.gradientTransform);

    return `radial-gradient(${radiusX}% ${radiusY}% at ${centerX}% ${centerY}%, ${mappedFill})`;
  }

  buildBackgroundValues(paintArray: any): string {
    if (typeof paintArray === 'symbol') {
      return '';
    }

    // If one fill and it's a solid, return the solid RGB color
    if (paintArray.length === 1 && paintArray[0].type === 'SOLID') {
      return this.htmlColorFromFills(paintArray);
    }

    // If multiple fills, deal with gradients and convert solid colors to a "dumb" linear-gradient
    const styles = paintArray.map((paint: any) => {
      if (paint.type === 'SOLID') {
        const color = this.htmlColorFromFills([paint]);
        return `linear-gradient(0deg, ${color} 0%, ${color} 100%)`;
      } else if (
        paint.type === 'GRADIENT_LINEAR' ||
        paint.type === 'GRADIENT_RADIAL' ||
        paint.type === 'GRADIENT_ANGULAR'
      ) {
        return this.htmlGradientFromFills([paint]);
      }

      return ''; // Handle other paint types safely
    });

    return styles.filter((value: any) => value !== '').join(', ');
  }

  htmlShadow(node: any): string {
    // [when testing] node.effects can be undefined
    if (node.effects && node.effects.length > 0) {
      const shadowEffects = node.effects.filter(
        (d: any) =>
          (d.type === 'DROP_SHADOW' ||
            d.type === 'INNER_SHADOW' ||
            d.type === 'LAYER_BLUR') &&
          d.visible,
      );

      if (shadowEffects.length > 0) {
        const shadow = shadowEffects[0];
        let x = 0;
        let y = 0;
        let blur = 0;
        let spread = '';
        let inner = '';
        let color = '';

        if (shadow.type === 'DROP_SHADOW' || shadow.type === 'INNER_SHADOW') {
          x = shadow.offset.x;
          y = shadow.offset.y;
          blur = shadow.radius;
          spread = shadow.spread ? `${shadow.spread}px ` : '';
          inner = shadow.type === 'INNER_SHADOW' ? ' inset' : '';
          color = this.htmlColor(shadow.color, shadow.color.a);
        } else if (shadow.type === 'LAYER_BLUR') {
          x = shadow.radius;
          y = shadow.radius;
          blur = shadow.radius;
        }

        // Return box-shadow in the desired format
        return `${x}px ${y}px ${blur}px ${spread}${color}${inner}`;
      }
    }
    return '';
  }

  shadow(node: any): this {
    if ('effects' in node) {
      const shadow = this.htmlShadow(node);
      if (shadow) {
        this.addStyles(this.formatWithJSX('box-shadow', this.htmlShadow(node)));
      }
    }
    return this;
  }

  nodeSize(node: any): any {
    const hasLayout =
      'layoutAlign' in node && node.parent && 'layoutMode' in node.parent;

    if (!hasLayout || node.textAutoResize === 'TRUNCATE') {
      return { width: node.width, height: node.height };
    }

    const nodeAuto = node.inferredAutoLayout || node;

    if ('layoutMode' in nodeAuto && nodeAuto.layoutMode === 'NONE') {
      return { width: node.width, height: node.height };
    }

    // const parentLayoutMode = node.parent.layoutMode;
    const parentLayoutMode =
      node.parent.inferredAutoLayout?.layoutMode || node.parent.layoutMode;

    const isWidthFill =
      (parentLayoutMode === 'HORIZONTAL' && nodeAuto.layoutGrow === 1) ||
      (parentLayoutMode === 'VERTICAL' && nodeAuto.layoutAlign === 'STRETCH');
    const isHeightFill =
      (parentLayoutMode === 'HORIZONTAL' &&
        nodeAuto.layoutAlign === 'STRETCH') ||
      (parentLayoutMode === 'VERTICAL' && nodeAuto.layoutGrow === 1);
    const modesSwapped = parentLayoutMode === 'HORIZONTAL';
    const primaryAxisMode = modesSwapped
      ? 'counterAxisSizingMode'
      : 'primaryAxisSizingMode';
    const counterAxisMode = modesSwapped
      ? 'primaryAxisSizingMode'
      : 'counterAxisSizingMode';

    return {
      width: isWidthFill
        ? 'fill'
        : 'layoutMode' in nodeAuto && nodeAuto[primaryAxisMode] === 'AUTO'
        ? null
        : node.width,
      height: isHeightFill
        ? 'fill'
        : 'layoutMode' in nodeAuto && nodeAuto[counterAxisMode] === 'AUTO'
        ? null
        : node.height,
    };
  }

  htmlSizePartial(
    node: any,
    isPreviewGlobal = false,
  ): { width: string; height: string } {
    if (isPreviewGlobal && node.parent === undefined) {
      return {
        width: this.formatWithJSX('width', '100%'),
        height: this.formatWithJSX('height', '100%'),
      };
    }

    const size = this.nodeSize(node);
    const nodeParent = node?.parent?.inferredAutoLayout || node?.parent;

    let w = '';
    if (typeof size.width === 'number') {
      w = this.formatWithJSX('width', size.width);
    } else if (size.width === 'fill') {
      if (
        nodeParent &&
        'layoutMode' in nodeParent &&
        nodeParent.layoutMode === 'HORIZONTAL'
      ) {
        w = this.formatWithJSX('flex', '1 1 0');
      } else {
        w = this.formatWithJSX('align-self', 'stretch');
      }
    }

    let h = '';
    if (typeof size.height === 'number') {
      h = this.formatWithJSX('height', size.height);
    } else if (typeof size.height === 'string') {
      if (
        nodeParent &&
        'layoutMode' in nodeParent &&
        nodeParent.layoutMode === 'VERTICAL'
      ) {
        h = this.formatWithJSX('flex', '1 1 0');
      } else {
        h = this.formatWithJSX('align-self', 'stretch');
      }
    }

    return { width: w, height: h };
  }

  size(node: any): this {
    const { width, height } = this.htmlSizePartial(node);
    if (
      node.textAutoResize !== 'TRUNCATE' &&
      node.textTruncation === 'ENDING'
    ) {
      this.addStyles(
        width,
        height,
        'white-space: nowrap',
        'overflow: hidden',
        'text-overflow: ellipsis',
      );
    }
    if (node.type === 'TEXT') {
      switch (node.textAutoResize) {
        case 'WIDTH_AND_HEIGHT':
          break;
        case 'HEIGHT':
          this.addStyles(width);
          break;
        case 'NONE':
          this.addStyles(width, height);
          break;
        case 'TRUNCATE':
          this.addStyles(
            width,
            height,
            'white-space: nowrap',
            'overflow: hidden',
            'text-overflow: ellipsis',
          );
          break;
      }
    } else {
      this.addStyles(width, height);
    }

    return this;
  }

  commonPadding(node: any): any {
    if ('layoutMode' in node && node.layoutMode !== 'NONE') {
      const paddingLeft = parseFloat((node.paddingLeft ?? 0).toFixed(2));
      const paddingRight = parseFloat((node.paddingRight ?? 0).toFixed(2));
      const paddingTop = parseFloat((node.paddingTop ?? 0).toFixed(2));
      const paddingBottom = parseFloat((node.paddingBottom ?? 0).toFixed(2));

      if (
        paddingLeft === paddingRight &&
        paddingLeft === paddingBottom &&
        paddingTop === paddingBottom
      ) {
        return { all: paddingLeft };
      } else if (paddingLeft === paddingRight && paddingTop === paddingBottom) {
        return {
          horizontal: paddingLeft,
          vertical: paddingTop,
        };
      } else {
        return {
          left: paddingLeft,
          right: paddingRight,
          top: paddingTop,
          bottom: paddingBottom,
        };
      }
    }

    return null;
  }

  htmlPadding(node: any): string[] {
    const padding = this.commonPadding(node);
    if (padding === null) {
      return [];
    }

    if ('all' in padding) {
      if (padding.all !== 0) {
        return [this.formatWithJSX('padding', padding.all)];
      } else {
        return [];
      }
    }

    const comp: string[] = [];

    // horizontal and vertical, as the default AutoLayout
    if ('horizontal' in padding) {
      if (padding.horizontal !== 0) {
        comp.push(this.formatWithJSX('padding-left', padding.horizontal));
        comp.push(this.formatWithJSX('padding-right', padding.horizontal));
      }
      if (padding.vertical !== 0) {
        comp.push(this.formatWithJSX('padding-top', padding.vertical));
        comp.push(this.formatWithJSX('padding-bottom', padding.vertical));
      }
      return comp;
    }

    if (padding.top !== 0) {
      comp.push(this.formatWithJSX('padding-top', padding.top));
    }
    if (padding.bottom !== 0) {
      comp.push(this.formatWithJSX('padding-bottom', padding.bottom));
    }
    if (padding.left !== 0) {
      comp.push(this.formatWithJSX('padding-left', padding.left));
    }
    if (padding.right !== 0) {
      comp.push(this.formatWithJSX('padding-right', padding.right));
    }
    // todo use REM

    return comp;
  }

  autoLayoutPadding(node: any): this {
    if ('paddingLeft' in node) {
      this.addStyles(...this.htmlPadding(node.inferredAutoLayout || node));
    }
    return this;
  }

  blur(node: any) {
    if ('effects' in node && node.effects.length > 0) {
      const _blur = node.effects.find(
        (e: any) => e.type === 'LAYER_BLUR' && e.visible,
      );
      if (_blur) {
        this.addStyles(
          this.formatWithJSX(
            'filter',
            `blur(${this.sliceNum(_blur.radius)}px)`,
          ),
        );
      }

      const backgroundBlur = node.effects.find(
        (e: any) => e.type === 'BACKGROUND_BLUR' && e.visible,
      );
      if (backgroundBlur) {
        this.addStyles(
          this.formatWithJSX(
            'backdrop-filter',
            `blur(${this.sliceNum(backgroundBlur.radius)}px)`,
          ),
        );
      }
    }
  }

  build(additionalStyle: Array<string> = []): string {
    this.addStyles(...additionalStyle);

    const formattedStyles = this.styles.map(s => s.trim());
    let formattedStyle = '';
    if (this.styles.length > 0) {
      formattedStyle = ` style="${formattedStyles.join('; ')}"`;
    }
    if (!this.name)
      this.name = 'dynamic_class-' + Math.random().toString(36).substring(7);
    //if (this.name.length > 0) {
    const classOrClassName = 'class';
    return ` ${classOrClassName}="${this.name}"${formattedStyle}`;
  }

  buildWithSeperateCSS(additionalStyle: Array<string> = []): {
    [key: string]: string;
  } {
    this.addStyles(...additionalStyle);
    if (!this.name)
      this.name = 'dynamic_class-' + Math.random().toString(36).substring(7);

    const formattedStyles = this.styles.map(s => s.trim());
    return {
      className: this.name,
      style: this.styles.length ? formattedStyles.join('; ') + '; ' : '',
    };
  }

  formatMultipleJSX(
    styles: Record<string, string | number | null>,
    isJsx: boolean,
  ): string {
    return (
      this.getEntries(styles)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([key, value]) => value)
        .map(([key, value]) => this.formatWithJSX(key, value!))
        .join(isJsx ? ', ' : '; ')
    );
  }
  getEntries(obj: any) {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  }

  getTextSegments(id: string): { style: string; text: string }[] {
    const segments = globalTextStyleSegments[id];
    if (!segments) {
      return [];
    }

    return segments.map((segment: any) => {
      const styleAttributes = this.formatMultipleJSX(
        {
          color: this.htmlColorFromFills(segment.fills),
          'font-size': segment.fontSize,
          'font-family': segment.fontName.family,
          'font-style': this.getFontStyle(segment.fontName.style),
          'font-weight': `${segment.fontWeight}`,
          'text-decoration': this.textDecoration(segment.textDecoration),
          'text-transform': this.textTransform(segment.textCase),
          'line-height': this.lineHeight(segment.lineHeight, segment.fontSize),
          'letter-spacing': this.letterSpacing(
            segment.letterSpacing,
            segment.fontSize,
          ),
          // "text-indent": segment.indentation,
          'word-wrap': 'break-word',
        },
        false,
      );

      const charsWithLineBreak = segment.characters.split('\n').join('<br/>');
      return { style: styleAttributes, text: charsWithLineBreak };
    });
  }

  fontSize(node: any, isUI = false): this {
    if (typeof node.fontSize !== 'symbol') {
      const value = isUI ? Math.min(node.fontSize, 24) : node.fontSize;
      this.addStyles(this.formatWithJSX('font-size', value));
    }
    return this;
  }

  textDecoration(textDecoration: any): string {
    switch (textDecoration) {
      case 'STRIKETHROUGH':
        return 'line-through';
      case 'UNDERLINE':
        return 'underline';
      case 'NONE':
        return '';
    }
    return '';
  }

  textTransform(textCase: any): string {
    switch (textCase) {
      case 'UPPER':
        return 'uppercase';
      case 'LOWER':
        return 'lowercase';
      case 'TITLE':
        return 'capitalize';
      case 'ORIGINAL':
      case 'SMALL_CAPS':
      case 'SMALL_CAPS_FORCED':
      default:
        return '';
    }
  }

  letterSpacing(letterSpacing: any, fontSize: number): number | null {
    const letterSpacingProp = this.commonLetterSpacing(letterSpacing, fontSize);
    if (letterSpacingProp > 0) {
      return letterSpacingProp;
    }
    return null;
  }

  commonLetterSpacing(letterSpacing: any, fontSize: number): number {
    switch (letterSpacing.unit) {
      case 'PIXELS':
        return letterSpacing.value;
      case 'PERCENT':
        return (fontSize * letterSpacing.value) / 100;
    }
    return 0;
  }

  commonLineHeight(lineHeight: any, fontSize: number): number {
    switch (lineHeight.unit) {
      case 'AUTO':
        return 0;
      case 'PIXELS':
        return lineHeight.value;
      case 'PERCENT':
        return (fontSize * lineHeight.value) / 100;
    }
    return 0;
  }

  lineHeight(lineHeight: any, fontSize: number): number | null {
    const lineHeightProp = this.commonLineHeight(lineHeight, fontSize);
    if (lineHeightProp > 0) {
      return lineHeightProp;
    }
    return null;
  }

  getFontStyle(style: string): string {
    if (style.toLowerCase().match('italic')) {
      return 'italic';
    }
    return '';
  }

  textAlign(node: any): this {
    // if alignHorizontal is LEFT, don't do anything because that is native

    // only undefined in testing
    if (node.textAlignHorizontal && node.textAlignHorizontal !== 'LEFT') {
      // todo when node.textAutoResize === "WIDTH_AND_HEIGHT" and there is no \n in the text, this can be ignored.
      let textAlign = '';
      switch (node.textAlignHorizontal) {
        case 'CENTER':
          textAlign = 'center';
          break;
        case 'RIGHT':
          textAlign = 'right';
          break;
        case 'TOP':
          textAlign = 'top';
          break;
        case 'BOTTOM':
          textAlign = 'bottom';
          break;
        case 'JUSTIFIED':
          textAlign = 'justify';
          break;
      }
      this.addStyles(this.formatWithJSX('text-align', textAlign));
    }
    return this;
  }
}
